/* ASM Store — ecommerce events para GA4 clásico (add_to_cart, view_item_list) */

(function () {

  /* ── add_to_cart: intercepta fetch a /cart/add.js ──────────── */
  var _origFetch = window.fetch;
  window.fetch = function (url, opts) {
    var result = _origFetch.apply(this, arguments);
    if (typeof url === 'string' && url.includes('/cart/add')) {
      result.then(function (res) {
        if (!res.ok) return;
        res.clone().json().then(function (data) {
          var items = Array.isArray(data.items) ? data.items : [data];
          gtag('event', 'add_to_cart', {
            currency: window.Shopify?.currency?.active || 'COP',
            value: items.reduce(function (s, i) { return s + (i.final_price / 100) * i.quantity; }, 0),
            items: items.map(function (i) {
              return {
                item_id: String(i.product_id),
                item_name: i.product_title || i.title,
                item_variant: i.variant_title || '',
                price: i.final_price / 100,
                quantity: i.quantity
              };
            })
          });
        }).catch(function () {});
      });
    }
    return result;
  };

  /* ── whatsapp_click: la venta se cierra por WhatsApp, así que ese clic es la conversión ── */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com"]');
    if (!a) return;
    var section = a.closest('[id^="shopify-section"]');
    var params = {
      link_text: ((a.textContent || '').trim() || a.getAttribute('aria-label') || '').slice(0, 60),
      link_location: a.closest('#wa-menu') ? 'flotante' : (section ? section.id.split('__').pop() : 'layout'),
      transport_type: 'beacon'
    };
    if (typeof gtag === 'function') gtag('event', 'whatsapp_click', params);
    if (typeof clarity === 'function') clarity('event', 'whatsapp_click');
  }, true);

  /* ── view_item_list: colecciones y búsqueda ─────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    var cards = document.querySelectorAll('.card-product, .product-card, [data-product-id]');
    if (!cards.length) return;
    var listName = document.title || 'product_list';
    var items = [];
    cards.forEach(function (card, idx) {
      var id = card.dataset.productId || card.querySelector('[data-product-id]')?.dataset.productId;
      var title = card.querySelector('.card__heading, .card__name')?.textContent?.trim();
      var priceEl = card.querySelector('.price-item--regular, .price__regular .price-item');
      if (!id && !title) return;
      items.push({
        item_id: id || '',
        item_name: title || '',
        index: idx + 1,
        price: priceEl ? parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) || 0 : 0
      });
    });
    if (items.length > 0) {
      gtag('event', 'view_item_list', {
        item_list_name: listName,
        items: items.slice(0, 20)
      });
    }
  });
})();
